export default "__VITE_ASSET__P4Mvu2VE__"